import React, { Component } from 'react';

import { HashRouter as Router, Route } from 'react-router-dom'
import { Provider } from 'mobx-react';

import store from '../store';
import shopStore from '../stores/shopStore';
import catalogStore from '../stores/catalogStore';
import DonationView from '../views/DonationView';

class DonationPrivateApp extends Component {
	constructor(props) {
		super(props);
		catalogStore.donationItems.replace([
			{
				id: '8497', //"7106",
				recordType: "noninventoryitem",
				values: {
					baseprice: "0.00",
					displayname: "Private Donation",
					isonline: true,
					itemid: "K-DN-P-2021-CHEVRE",
					storedescription: "",
					storedetaileddescription: "",
					storedisplayimage: [],
					storedisplayname: "Private Donation",
					storedisplaythumbnail: [],
				}	
			}	
		]);
		catalogStore.selectedDonationItem.set(catalogStore.donationItems[0]);
	}

  	render() {
		const context = window.tkcWidgetContext;
		store.netsuiteBaseUrl = context.netsuiteBaseUrl;
		store.guestSessionMode = true;		
		if (context.billingInfo) {
			shopStore.billingInfo.replace(context.billingInfo);
		}	
		catalogStore.displayOnly = context.displayOnly || null;	
		catalogStore.recurringByDefault = context.recurringByDefault || false;
		return (
			<Provider store={store} shopStore={shopStore} catalogStore={catalogStore}>          
				<Router>
					<span className="tkc-widget-container">                              
						<Route path="/" component={DonationView} /> 
					</span>
				</Router>          
			</Provider>
		);
		
  	}

}

export default DonationPrivateApp;



// WEBPACK FOOTER //
// ./src/apps/DonationPrivateApp.js